import { CarOutlined, RocketOutlined } from '@ant-design/icons';
import { Switch, Space, Card } from 'antd';
import React from 'react';

function Switches() {
  return (
    <Card title="Switches">
      <Space>
      <Switch defaultChecked />
      <Switch checkedChildren="Metis" unCheckedChildren="Thebe" defaultChecked />
      <Switch defaultChecked disabled/>
      <Switch
        checkedChildren={<RocketOutlined />}
        unCheckedChildren={<CarOutlined />}
      />
      </Space>
    </Card>
  )
}


export default Switches;
